module.exports = __webpack_public_path__ + "assets/img/chronicleImgActive-d5310af3.png";